<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col class="text-center" cols="12">
        <v-progress-circular
          v-if="status === 'loading'"
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
        
        <h2 class="mt-4 text-h6 font-weight-medium">
          {{ message }}
        </h2>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  data: () => ({
    status: 'loading',
    message: 'Finalizing your connection with Teya...'
  }),
  async mounted() {
    // Extract parameters injected by Teya into the URL query
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');

    if (!code || !state) {
      this.status = 'error';
      this.message = 'Authorization code or session metadata missing.';
      return;
    }

    try {
      // Pass code and state back to Express to finish the exchange securely
      const response = await axios.post('http://localhost:3000/api/teya/token', {
        code,
        state
      });

      // Save tokens securely (consider HttpOnly cookies on production backends)
      localStorage.setItem('teya_access_token', response.data.access_token);
      
      this.status = 'success';
      this.message = 'Successfully authenticated!';

      // Redirect back to your main settings screen after a quick success presentation
      setTimeout(() => {
        this.$router.push('/settings'); 
      }, 1500);

    } catch (error) {
      this.status = 'error';
      this.message = 'Failed to verify authentication with Teya. Please try again.';
      console.error(error);
    }
  }
};
</script>